import { ContentBox } from '$comp/navigation-bar-tool-box/components/content-box'
import { ConnectivityToolsIcon } from '$common/icons/navitation-bar-tool-box/connectivity-tools'
import { t } from '$i18n'

export function ConnectivityTools({ onClick }: { onClick: () => void }) {
  return (
    <ContentBox
      title={t('navigationBarToolBox.connectivityTools.title')}
      description={t('navigationBarToolBox.connectivityTools.description')}
      rootSx={{
        background: 'linear-gradient(180deg, #00B09B 0%, #96C93D 100.48%)',
      }}
      icon={<ConnectivityToolsIcon />}
      onClick={onClick}
    />
  )
}
